import React, {Component} from 'react'
import BasketsPage from './BasketsPage'
import '../styles/index.scss'


class BasketsPageContainer extends Component {
    render() {
        return (
            <div className='BasketsPageContainer'>
                <BasketsPage/>
            </div>
        )
    }
}

export default BasketsPageContainer
